<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11 0.5C5.20167 0.5 0.5 5.20167 0.5 11C0.5 16.7983 5.20167 21.5 11 21.5C11.9683 21.5 12.75 20.7183 12.75 19.75C12.75 19.295 12.575 18.8867 12.295 18.5717C12.0267 18.2683 11.8517 17.86 11.8517 17.4167C11.8517 16.4483 12.6333 15.6667 13.6017 15.6667H15.6667C18.8867 15.6667 21.5 13.0533 21.5 9.83333C21.5 4.67667 16.7983 0.5 11 0.5ZM4.58333 11C3.615 11 2.83333 10.2183 2.83333 9.25C2.83333 8.28167 3.615 7.5 4.58333 7.5C5.55167 7.5 6.33333 8.28167 6.33333 9.25C6.33333 10.2183 5.55167 11 4.58333 11ZM8.08333 6.33333C7.115 6.33333 6.33333 5.55167 6.33333 4.58333C6.33333 3.615 7.115 2.83333 8.08333 2.83333C9.05167 2.83333 9.83333 3.615 9.83333 4.58333C9.83333 5.55167 9.05167 6.33333 8.08333 6.33333ZM13.9167 6.33333C12.9483 6.33333 12.1667 5.55167 12.1667 4.58333C12.1667 3.615 12.9483 2.83333 13.9167 2.83333C14.885 2.83333 15.6667 3.615 15.6667 4.58333C15.6667 5.55167 14.885 6.33333 13.9167 6.33333ZM17.4167 11C16.4483 11 15.6667 10.2183 15.6667 9.25C15.6667 8.28167 16.4483 7.5 17.4167 7.5C18.385 7.5 19.1667 8.28167 19.1667 9.25C19.1667 10.2183 18.385 11 17.4167 11Z"
      fill="#495057"
    />
  </svg>
</template>

<script>
export default {
  name: 'IconBreed',
  props: {
    width: {
      type: Number,
      default: 20,
    },
    height: {
      type: Number,
      default: 20,
    },
  },
};
</script>

<style scoped>
</style>